const getSportsbookUrl = () => {
	return location.host === "localhost"
		? window.SPORTSBOOK_URL
		: `${location.protocol}//sportsbook.${location.host}`;
};
const dev = {
	"auth-api": window.AUTH_SERVICE_V2 ? "/api/authmanagement/v2" : "/api/authmanagement/v1",
	"coupon-api": "/api/couponmanagement/v1",
	"bonus-api": "/api/bonusmanagement/v1",
	"wallet-api": "/api/balancemanagement/v1",
	"transaction-api": "/api/transactionmanagement/v1",
	"account-api": "/api/accountmanagement/v1",
	"sportsbook": "/api/sportsbook/v1",
	"notification-api": "/api/notificationmanagement/v1",
	"affiliate-api": "/api/affiliateapplicationmanagement/v1",
	"document-api": "/api/documentmanagement/v1",
	"payment-api": "/api/paymentsintegrationmanagement/v1",
	"third-party-api": "/api/thirdpartyintegrationmanagement/v1",
	"third-party-api-v2": "/api/thirdpartyintegrationmanagement/v2",
	"user-socket-api": "/wsapp",
	"wo-api": "https://api.int.wiseodds.com/api/v1",
	"tenant-api": "/api/tenant-cockpit/v1",
	"content-api": "/api/contentmanagement/v1",
	"wo-app": "https://app.int.wiseodds.com/",
	"wo-operatorId": "a154f0ff-bde9-4058-9bda-6e60668745c9",
	"sports-book-iframe": `${getSportsbookUrl()}/api/v1/authorize`,
	"base": "betlumina.com",
	"sportsbook-api": `${getSportsbookUrl()}/api/v1`,
	"digitain-api": "https://sport.piramitapps.com",
	"electrobet-api": "https://wisegaming.electrobets.dev",
	"riskmanagement-api": "/api/riskmanagement/v1",
	"sumsub-api": "/api/sumsub/v1",
	"sumsub-socket-api": "wss://betlumina.com/wsapp-key",
	"chat-api": "/api/chat/v1",
};

const int = {
	"auth-api": window.AUTH_SERVICE_V2 ? "/api/authmanagement/v2" : "/api/authmanagement/v1",
	"coupon-api": "/api/couponmanagement/v1",
	"bonus-api": "/api/bonusmanagement/v1",
	"wallet-api": "/api/balancemanagement/v1",
	"transaction-api": "/api/transactionmanagement/v1",
	"affiliate-api": "/api/affiliateapplicationmanagement/v1",
	"account-api": "/api/accountmanagement/v1",
	"notification-api": "/api/notificationmanagement/v1",
	"document-api": "/api/documentmanagement/v1",
	"tenant-api": "/api/tenant-cockpit/v1",
	"payment-api": "/api/paymentsintegrationmanagement/v1",
	"sportsbook": "/api/sportsbook/v1",
	"third-party-api": "/api/thirdpartyintegrationmanagement/v1",
	"third-party-api-v2": "/api/thirdpartyintegrationmanagement/v2",
	"user-socket-api": "/wsapp",
	"wo-api": "https://api.int.wiseodds.com/api/v1",
	"wo-app": "https://app.int.wiseodds.com/",
	"wo-operatorId": "ac2598ce-2c0c-49ee-b5ad-e1c7f6ed1757",
	"content-api": "/api/contentmanagement/v1",
	"sports-book-iframe": `${getSportsbookUrl()}/api/v1/authorize`,
	"sportsbook-api": `${getSportsbookUrl()}/api/v1`,
	"digitain-api": window.DIGITAIN_HOST,
	"electrobet-api": "https://wisegaming.electrobets.dev",
	"riskmanagement-api": "/api/riskmanagement/v1",
	"sumsub-api": "/api/sumsub/v1",
	"sumsub-socket-api": `wss://${window.location.host}/wsapp-key`,
	"chat-api": "/api/chat/v1",
};

const prod = {
	"auth-api": window.AUTH_SERVICE_V2 ? "/api/authmanagement/v2" : "/api/authmanagement/v1",
	"coupon-api": "/api/couponmanagement/v1",
	"bonus-api": "/api/bonusmanagement/v1",
	"account-api": "/api/accountmanagement/v1",
	"wallet-api": "/api/balancemanagement/v1",
	"transaction-api": "/api/transactionmanagement/v1",
	"notification-api": "/api/notificationmanagement/v1",
	"document-api": "/api/documentmanagement/v1",
	"payment-api": "/api/paymentsintegrationmanagement/v1",
	"sportsbook": "/api/sportsbook/v1",
	"affiliate-api": "/api/affiliateapplicationmanagement/v1",
	"tenant-api": "/api/tenant-cockpit/v1",
	"third-party-api": "/api/thirdpartyintegrationmanagement/v1",
	"third-party-api-v2": "/api/thirdpartyintegrationmanagement/v2",
	"user-socket-api": "/wsapp",
	"content-api": "/api/contentmanagement/v1",
	"wo-api": "https://api.wiseodds.com/api/v1",
	"wo-app": "https://app.wiseodds.com/",
	"wo-operatorId": "7a8edd9f-c833-479b-b8e0-5f45ab19dae2",
	"sports-book-iframe": `${getSportsbookUrl()}/api/v1/authorize`,
	"sportsbook-api": `${getSportsbookUrl()}/api/v1`,
	"digitain-api": window.DIGITAIN_HOST,
	"electrobet-api": "https://wisegaming.appservices.app",
	"riskmanagement-api": "/api/riskmanagement/v1",
	"sumsub-api": "/api/sumsub/v1",
	// "sumsub-socket-api": `wss://${window.location.host}/wsapp-key`, TODO: Temporary until figuring out the issue with the socket connection to that endpoint
	"sumsub-socket-api": "wss://qu7qunwb72.execute-api.eu-central-1.amazonaws.com/wsapp-key",
	"chat-api": "/api/chat/v1",
};
const currentEnv = window.ENV === "prod" ? prod : window.ENV === "int" ? int : dev;
module.exports = currentEnv;
